import {
  LegacyModal,
  Link,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  PrimaryButton,
  Text,
} from "@certn/cascadia-react";
import { Trans, useTranslation } from "react-i18next";
import { useOverlayTriggerState } from "react-stately";

type ConsentRequiredModalProps = {
  show: boolean;
  onClose: () => void;
};

export function ConsentRequiredModal({
  show,
  onClose,
}: ConsentRequiredModalProps) {
  const { t } = useTranslation();
  const modalState = useOverlayTriggerState({});

  if (!show) {
    return null;
  }

  return (
    <ModalOverlay state={modalState}>
      <LegacyModal width="456px">
        <ModalHeader
          close={onClose}
          title={t("Consent required")}
          testID="consent-required-modal"
        />

        <ModalContent testID="consent-required-modal">
          <Text style="global/body-primary">
            <Trans>
              Consent to run a check is required in order to move forward.
            </Trans>
            <br />
            <br />
            <Trans>
              If you do not consent, you may close this window and exit your
              application. For further assistance please reach out to Certn
              Support at{" "}
              <Link testID="support-link" textColor="text-base">
                support@certn.co
              </Link>
              .
            </Trans>
          </Text>
        </ModalContent>

        <ModalFooter>
          <PrimaryButton
            type="submit"
            size="medium"
            onPress={onClose}
            testID="consent-required-modal-close-button"
          >
            <Trans>Close</Trans>
          </PrimaryButton>
        </ModalFooter>
      </LegacyModal>
    </ModalOverlay>
  );
}
